import { render, staticRenderFns } from "./ReadDemanda.vue?vue&type=template&id=292d949c"
import script from "./ReadDemanda.vue?vue&type=script&lang=js"
export * from "./ReadDemanda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports